import { Task } from './task'
import { Option } from './option'
import { TaskReflection } from './task-reflection'

export interface EnrollActivityTaskInterface {
  task?: Task
  /**
   * 报名选项
   */
  options?: Option[]
  /**
   * 后台用户请求接口
   *  - 是否有人提交
   */
  isSubmit?: boolean
  /**
   * 前台用户请求接口
   *  - 当前用户完成情况
   */
  taskCompletedInfo?: TaskReflection | null
}

export class EnrollActivityTask implements EnrollActivityTaskInterface {
  task?: Task
  /**
   * 报名选项
   */
  options?: Option[]
  /**
   * 后台用户请求接口
   *  - 是否有人提交
   */
  isSubmit?: boolean
  /**
   * 前台用户请求接口
   *  - 当前用户完成情况
   */
  taskCompletedInfo?: TaskReflection | null

  constructor(props: EnrollActivityTaskInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      task: _task,
      options: _options,
      isSubmit: _isSubmit,
      taskCompletedInfo: _taskCompletedInfo,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.task = _task ? new Task(_task) : _task
    this.options = _options ? _options.map((i) => new Option(i)) : _options
    this.isSubmit = _isSubmit
    this.taskCompletedInfo = _taskCompletedInfo
      ? new TaskReflection(_taskCompletedInfo)
      : _taskCompletedInfo
  }
}
